import { memo } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/lib/Button';

import ChevronRightBoldIcon from 'components/icons/ChevronRightBoldIcon.com.svg';

import cn from './styles.local.less';

function ChevronButton({ children, ...props }) {
  return (
    <Button {...props}>
      {children}
      <ChevronRightBoldIcon className={cn.icon} />
    </Button>
  );
}

ChevronButton.propTypes = {
  children: PropTypes.node.isRequired,
};

export default memo(ChevronButton);
